<template>
  <div class="m-compment-header">
    <img v-if="logoColor === 'black'" src="@/assets/mobile/home/logo_black.png" alt="Logo" class="logo" @click="goHome">
    <img v-else src="@/assets/mobile/home/logo.png" alt="Logo" class="logo" @click="goHome">
  </div>
</template>

<script>
export default {
  name: 'MobileHeader',
  props: {
    logoColor: {
      type: String,
      default: 'white'
    }
  },
  mounted(){
	  
  },
  methods: {
    goHome() {
      this.$router.push('/m')
    }
  }
}
</script>

<style scoped>
.m-compment-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 45rem;          /* 如果单位是 rem，确保根字体大小合适 */
  background-color: transparent;
  pointer-events: none;
  text-align: center;     /* 确保图片水平居中（当图片不是块级时） */
  text-align: center;
   z-index: 1000;   /* 确保在最上层 */
}


.logo {
  display: block;         /* 块级元素自动占满宽度 */
  width: 100%;
  height: auto;
  pointer-events: auto;
}
</style>
